var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound52B = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M44.758 21.151a2.5 2.5 0 0 1-3.062-1.767L38.849 8.758a2.5 2.5 0 0 1 1.768-3.062l9.659-2.588a2.5 2.5 0 0 1 3.062 1.768l2.847 10.625a2.5 2.5 0 0 1-1.768 3.062l-9.66 2.588Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M46.208 20.763a1 1 0 0 1 .707-1.225l7.244-1.941a1.5 1.5 0 0 0 1.06-1.837L52.374 5.134a1.5 1.5 0 0 0-1.837-1.06l-7.245 1.94a1 1 0 1 1-.517-1.931l7.244-1.941a3.5 3.5 0 0 1 4.286 2.475l2.848 10.625a3.5 3.5 0 0 1-2.475 4.287l-7.245 1.94a1 1 0 0 1-1.224-.706Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M40.617 54.304a2.5 2.5 0 0 1-1.768-3.062l2.847-10.625a2.5 2.5 0 0 1 3.062-1.768l9.659 2.588a2.5 2.5 0 0 1 1.768 3.062l-2.847 10.625a2.5 2.5 0 0 1-3.062 1.768l-9.66-2.588Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M42.066 54.692a1 1 0 0 1 1.225-.707l7.245 1.941a1.5 1.5 0 0 0 1.837-1.06L55.22 44.24a1.5 1.5 0 0 0-1.06-1.837l-7.245-1.94a1 1 0 1 1 .517-1.933l7.245 1.941a3.5 3.5 0 0 1 2.475 4.287l-2.847 10.625a3.5 3.5 0 0 1-4.287 2.475l-7.245-1.941a1 1 0 0 1-.707-1.225Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M16.5 39.334a2.5 2.5 0 0 1 2.5 2.5V53.5a2.5 2.5 0 0 1-2.5 2.5h-10A2.5 2.5 0 0 1 4 53.5V39.334h12.5ZM16.5 21.666a2.5 2.5 0 0 1 2.5 2.5v11.667a2.5 2.5 0 0 1-2.5 2.5H4V21.667h12.5ZM16.5 4A2.5 2.5 0 0 1 19 6.5v11.667a2.5 2.5 0 0 1-2.5 2.5H4V6.5A2.5 2.5 0 0 1 6.5 4h10Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M15 56a1 1 0 0 1-1 1H6.5A3.5 3.5 0 0 1 3 53.5v-47A3.5 3.5 0 0 1 6.5 3H14a1 1 0 1 1 0 2H6.5A1.5 1.5 0 0 0 5 6.5v47A1.5 1.5 0 0 0 6.5 55H14a1 1 0 0 1 1 1Z",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 40,
  r: 7,
  fill: "#464D57",
  transform: "rotate(-90 30 40)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 20,
  r: 7,
  fill: "#464D57",
  transform: "rotate(-90 30 20)"
})));
SvgRound52B.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound52B);
export default ForwardRef;